import {map, take} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../../shared/api.service';

@Injectable()
export class RecentRecordingsService {

  constructor(private http: HttpClient,
              private apiService: ApiService) {}

  public getRecordings() : Observable<any> {
    return this.http.get(this.apiService.getRecordings()).pipe(take(1),map(value => {
      return value;
    }),);
  }
}
